import type { FindingStatus } from "@/api/usePolicyException.types"
import type { PolicyExceptionStatus } from "@/api/useScanHistory.types"
import type { Permission } from "@/domain/user"
import type { Status } from "@/molecules/StatusTag"

export const PENDING_POLICY_EXCEPTION: PolicyExceptionStatus = "pending"

// Deciding requests; only admins have it.
export const POLICY_EXCEPTIONS_WRITE: Permission = {
  resource: "scm.policy-exceptions",
  action: "write"
}

export const EXCEPTION_CONFLICT_REASONS = [
  "VERSION_CONFLICT",
  "REQUEST_EXISTS",
  "NO_BLOCKING_FINDINGS",
  "NOT_FOUND",
  "INVALID_REQUEST"
] as const

// The longest explanation or decision note kosmos-api takes.
export const POLICY_EXCEPTION_TEXT_MAX_LENGTH = 2000

// The most findings kosmos-api takes in one request.
export const POLICY_EXCEPTION_MAX_FINDINGS = 500

export const FINDING_STATUS_TAGS: Record<FindingStatus, Status> = {
  pending: "pending",
  approved: "success",
  rejected: "failed",
  unspecified: "neutral"
}
